import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IUserStampsCollectionHistory } from '@/shared/model/user-stamps-collection-history.model';

const baseApiUrl = 'api/user-stamps-collection-histories';
const baseSearchApiUrl = 'api/_search/user-stamps-collection-histories?query=';

export default class UserStampsCollectionHistoryService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IUserStampsCollectionHistory> {
    return new Promise<IUserStampsCollectionHistory>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IUserStampsCollectionHistory): Promise<IUserStampsCollectionHistory> {
    return new Promise<IUserStampsCollectionHistory>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IUserStampsCollectionHistory): Promise<IUserStampsCollectionHistory> {
    return new Promise<IUserStampsCollectionHistory>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
